import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ROUTES } from '../../utils/constants';
import Button from '../Common/Button';
import '../../styles/navigation.css';

const Navigation: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // Debug logging (remove in production)
  // console.log('🧭 Navigation rendering, current path:', location.pathname);

  const navigationItems = [
    {
      path: ROUTES.CHARACTER_SHEET,
      label: 'Character Sheet',
      icon: '📝',
    },
    {
      path: ROUTES.BIOGRAPHY,
      label: 'Biography',
      icon: '📖',
    },
    {
      path: ROUTES.COMBAT_TRACKER,
      label: 'Combat Tracker',
      icon: '⚔️',
    },
    {
      path: ROUTES.CONTENT_LIBRARY,
      label: 'Content Library',
      icon: '📚',
    },
  ];

  const handleNavigate = (path: string) => {
    navigate(path);
  };

  return (
    <nav className="navigation">
      <div className="navigation__container">
        {navigationItems.map((item) => (
          <Button
            key={item.path}
            variant={location.pathname === item.path ? 'PRIMARY' : 'SECONDARY'}
            size="LARGE"
            onClick={() => handleNavigate(item.path)}
            className={`navigation__button ${
              location.pathname === item.path ? 'navigation__button--active' : ''
            }`}
          >
            <span className="navigation__icon">{item.icon}</span>
            <span className="navigation__label">{item.label}</span>
          </Button>
        ))}
      </div>
    </nav>
  );
};

export default Navigation;